import React, { FC, useReducer } from 'react';

import { SearchFilterProvider } from 'providers';
import { useReleases } from 'hooks';

import ResultsV2 from './ResultsV2';
import Results from './Results';
import {
  initialSearchESState,
  SearchEveryoneSocialContext,
  searchEveryoneSocialReducer,
} from 'features/search/SearchESContext';
import { FilterBar } from 'features/search/components';

const Search: FC = () => {
  const releases = useReleases();
  const hasImproveSearch = releases.includes('improveSearch');

  const [state, dispatch] = useReducer(searchEveryoneSocialReducer, initialSearchESState);

  if (hasImproveSearch) {
    return (
      <SearchEveryoneSocialContext.Provider value={{ state, dispatch }}>
        <SearchFilterProvider>
          <FilterBar />
          <ResultsV2 />
        </SearchFilterProvider>
      </SearchEveryoneSocialContext.Provider>
    );
  }

  return <Results />;
};

export default Search;
